import React from "react"
import "../../styles/Common/TextMultiStyle.less"
import DOMPurify from "dompurify"

export default function TextMultiStyle(props) {
  return (
    <div onClick={props.onClick}>
      <h2 className={props.StyleText} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.text) }}></h2>
    </div>
  )
}
